module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0710-min.0fd20679.jpg";